import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationRoofTiles: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={356}
        height={228}
      >
        <path d="M0 0h356v228H0V0Z" fill="#C0C2C9" />
      </mask>
      <g mask="url(#a)">
        <path
          d="M337 161c0 88.366-71.634 160-160 160S17 249.366 17 161 88.634 1 177 1s160 71.634 160 160Z"
          fill={colors.primary[50]}
        />
        <path
          d="m178.037 63.124-71.302 71.296v91.131h142.599V134.42l-71.297-71.296Z"
          fill="#fff"
          stroke={colors.primary[200]}
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M249.334 55.985a7.313 7.313 0 0 0-7.312-7.312h-12.085a7.313 7.313 0 0 0-7.311 7.312v14.464L249.36 96.87l-.026-40.886Z"
          fill={colors.primary[100]}
          stroke={colors.primary[200]}
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m272.153 119.431-81.586-80.642a17.826 17.826 0 0 0-25.066 0L83.915 119.43a13.368 13.368 0 0 0 18.904 18.904l75.218-75.211 75.212 75.211a13.367 13.367 0 0 0 18.904-18.904Z"
          fill={colors.primary[200]}
          stroke={colors.primary[500]}
          strokeWidth={4}
          strokeLinejoin="round"
        />
        <path
          d="M191.385 115.542a13.376 13.376 0 0 1-15.986 13.116 13.37 13.37 0 0 1-10.506-10.511 13.38 13.38 0 0 1 5.693-13.728 13.372 13.372 0 0 1 20.799 11.123ZM195.858 155.617h35.648v35.648h-35.648v-35.648Z"
          fill={colors.primary[100]}
          stroke={colors.primary[200]}
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M195.858 173.444h35.648"
          stroke={colors.primary[200]}
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M169.124 170.84a17.83 17.83 0 0 0-17.824-18.172 17.838 17.838 0 0 0-12.727 5.344 17.83 17.83 0 0 0-5.097 12.828v35.648h35.648V170.84Z"
          fill={colors.primary[100]}
          stroke={colors.primary[200]}
          strokeWidth={4}
          strokeLinejoin="round"
        />
        <path
          d="M125.252 208.948a5 5 0 0 1 5-5h44.162a5 5 0 0 1 5 5v15.927h-54.162v-15.927Z"
          fill={colors.primary[100]}
          stroke={colors.primary[200]}
          strokeWidth={4}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 226a2 2 0 0 1 2-2h310a2 2 0 1 1 0 4H22a2 2 0 0 1-2-2Z"
          fill={colors.primary[500]}
        />
      </g>
    </svg>
  );
};

export default IllustrationRoofTiles;
